<template>
  <div id="app">
    <div v-if="!isLoggedIn">
      <ConsentForm @login-success="handleLoginSuccess" />
    </div>
    <div v-else-if="isLoggedIn && !isDemoCompleted">
      <DemoProcedure @demo-complete="handleDemoComplete" />
    </div>
    <div v-else>
      <!-- <ImageRecorder :images="images" :prompts="prompts" :pin="pin" :accessibilitySettings="accessibilitySettings" /> -->
      <ImageRecorder :mediaList="mediaList" :pin="pin" :accessibilitySettings="accessibilitySettings" />

    </div>
  </div>
</template>

<script>
import ConsentForm from './components/ConsentForm.vue';
import ImageRecorder from './components/ImageRecorder.vue';
import DemoProcedure from './components/DemoProcedure.vue';
import axios from 'axios';

export default {
  components: {
    ConsentForm,
    ImageRecorder,
    DemoProcedure,
  },
  data() {
    return {
      isLoggedIn: false,
      isDemoCompleted: false,
      pin: '',
      images: [],
      mediaList: [], // <- was images
      prompts: [],
      accessibilitySettings: {
        fontSize: 'medium',
      },
    };
  },
  methods: {
    handleLoginSuccess(pin) {
      this.isLoggedIn = true;
      this.pin = pin;
    },
    handleDemoComplete(settings) {
      this.isDemoCompleted = true;
      this.accessibilitySettings = settings;
    },
    // async fetchMedia() {
    //   try {
    //     const response = await axios.get('https://firefly-study.athenarc.gr/media');
    //     const media = response.data;
    //     this.images = media.map((item) => item.filePath);
    //     this.prompts = media.map((item) => item.caption);
    //   } catch (error) {
    //     console.error('Error fetching media:', error);
    //   }
    // },
    async fetchMedia() {
      try {
        const response = await axios.get('https://firefly-study.athenarc.gr/media');
        const media = response.data;

        this.mediaList = media.map(item => ({
          src: `https://firefly-study.athenarc.gr/${item.filePath}`,
          caption: item.caption,
          type: item.type  // 'video' or 'image' directly from DB
        }));
      } catch (error) {
        console.error('Error fetching media:', error);
      }
    },
  },
  created() {
    this.fetchMedia();
  },
};
</script>



<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 60px;
}

button {
  padding: 10px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background: #0056b3;
}
</style>
